import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { type LinkedInJobStatus, statusLabel } from "@/types/linkedin";

const VARIANTS: Record<LinkedInJobStatus, string> = {
  pending: "bg-muted text-muted-foreground",
  uploading: "bg-blue-100 text-blue-800",
  extracting: "bg-blue-100 text-blue-800",
  enriching: "bg-blue-100 text-blue-800",
  matching: "bg-blue-100 text-blue-800",
  diffing: "bg-blue-100 text-blue-800",
  awaiting_match: "bg-yellow-100 text-yellow-800",
  review_ready: "bg-purple-100 text-purple-800",
  no_changes: "bg-gray-200 text-gray-700",
  applied: "bg-green-100 text-green-800",
  failed: "bg-red-100 text-red-800",
  cancelled: "bg-gray-100 text-gray-600",
};

export function LinkedInStatusBadge({ status }: { status: LinkedInJobStatus }) {
  return (
    <Badge variant="secondary" className={cn("font-normal", VARIANTS[status])}>
      {statusLabel(status)}
    </Badge>
  );
}
